// Copyright (c) Docugami, Inc. All rights reserved.

import { DocSetStatus, DocSetStatusInfo, getDocSetDocuments } from "components/cluster_management/DocSetStatus";
import { getExtension } from "components/file_management/file_helpers";
import { themeRed } from 'components/shell/presentation/AppStyles';
import { useInitializer } from 'hooks/deepLinkInitializer';
import { useAppSelector } from 'hooks/redux';
import { ClusterDocument } from "networking/api";

export function isValidDocument(document: ClusterDocument) {
    const extension = getExtension(document.filename).toLowerCase();
    return !!document.hasCpml && extension === ".docx";
}

function getAssistedAuthoringDocSetStatus(documents: ClusterDocument[]): DocSetStatusInfo | undefined {
    if (!documents.find(isValidDocument)) {
        // There is no valid docx file in this docset
        return {
            status: DocSetStatus.None,
            label: 'Invalid',
            details: 'This doc set does not contain any supported .docx files for authoring in Word',
            statusColor: themeRed
        }
    }
}

export function useAssistedAuthoringDocSetStatus(docSetId: string, skip?: boolean) {
    const [isInitialized] = useInitializer({ clusterId: !skip ? docSetId : undefined });
    const docSetDocuments = useAppSelector(state => getDocSetDocuments(state, !skip ? docSetId : ""));

    return !skip ? { isLoading: !isInitialized, statusInfo: getAssistedAuthoringDocSetStatus(docSetDocuments) } : undefined;
}
